import React from "react";

const PersonalInfo = () => {
  const personalInfoContent = [
    {
      id: 1,
      colClass: "left",
      info: [
        {
          id: 1,
          name: "Address",
          content: "Somerville, MA",
        },
        {
          id: 2,
          name: "Email",
          content: (
            <>
              <a href="mailto:scott.ankiewicz@outlook.com">
                scott.ankiewicz@outlook.com
              </a>
            </>
          ),
        },
        {
          id: 3,
          name: "Phone",
          content: "(978) 289 - 8008",
        },
      ],
    },
    {
      id: 2,
      colClass: "right",
      info: [
        {
          id: 1,
          name: "School",
          content: "University of Massachusetts - Lowell",
        },
        {
          id: 2,
          name: "Interests",
          content: "Hiking, Board Games, Photography",
        },
        {
          id: 3,
          name: "Freelance",
          content: "Available",
        },
      ],
    },
  ];
  return (
    <>
      {personalInfoContent.map((item) => (
        <div className={item.colClass} key={item.id}>
          <div className="tokyo_tm_info">
            <ul>
              {item?.info?.map((value) => (
                <li key={value.id}>
                  <span>{value.name}:</span>
                  <span>{value.content}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default PersonalInfo;
